if (!customElements.get('product-single-bundle-form')) {
  customElements.define('product-single-bundle-form', class ProductSingleBundleForm extends HTMLElement {
    constructor() {
      super();
      this.maxNumber = 0;
      this.freeQuantityCounter = 0;
      
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.stepBackSelector = this.querySelector(".first-step-back"); 
      this.quantityButtonsFree = this.querySelectorAll(".quantity-button-free");
      this.quantityBoxOpenrButtonsFreee = this.querySelectorAll(".custom-item-qty-opener-free");
      this.variantJSON = JSON.parse(this.querySelector(".custom-variant-template-data").textContent);
       
      this.initEventListeners();
    }
    initEventListeners(){
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
         
         this.quantityButtonsFree.forEach( (el) => {
          el.addEventListener("click",this.quantityChangeHandlerFree.bind(this));
        });
        this.quantityBoxOpenrButtonsFreee.forEach( (el) => {
          el.addEventListener("click",this.openQuantityBoxFree.bind(this));
        });
         this.stepBackSelector.addEventListener("click",this.getStepOne.bind(this));
         /*if(this.querySelectorAll(`div.product-bundle-items-wrapper-free[data-size="1"]`).length > 0){
           this.querySelector("div.product-bundle-items-wrapper-free .custom-item-qty-opener-free").classList.add("hidden");
           this.querySelector("div.product-bundle-items-wrapper-free .product-bundle-item-quantity-wrapper").classList.add("hidden");
         }*/
      
    }
    getStepOne(evt){
        this.closest(".custom-modal__centered.active").classList.remove("active");
         this.updateButtonState(this.maxNumber);
    }
    
    connectedCallback() {
        
    }
    updateButtonState(maxNumber){
      
       this.maxNumber = maxNumber;
      const selectedSize = document.querySelector(`.custom-variant-noflex-items select[name="option-selector"]`).value;
      this.querySelectorAll(".product-bundle-item-quantity-wrapper .custom-qty-box-input").forEach( (el) => {
          const color = el.dataset.color;
          const selectedVaraint = this.variantJSON.filter(variant => variant.option1.match(color) && variant.option2 == selectedSize);
          console.log(selectedVaraint,selectedSize,color);
          if(selectedVaraint.length <= 0){
            this.freeQuantityCounter = this.freeQuantityCounter - el.value;
            el.value = 0;
            el.parentNode.parentNode.classList.add("hidden");
          }else{
             el.parentNode.parentNode.classList.remove("hidden");
          }
      });
      this.submitButton.querySelector("span.bundle-message-free .bundle-counter-free").textContent = `${this.freeQuantityCounter}/${this.maxNumber}`;
      console.log(this.freeQuantityCounter >= this.maxNumber,this.freeQuantityCounter,this.maxNumber);
       if(this.freeQuantityCounter == this.maxNumber){
         this.querySelectorAll(".product-bundle-item-wrapper-free").forEach( (el) => {
           const mainElement = el;
           if(el.querySelector(".custom-qty-box-input").value > 0){
             el.querySelector("button.plus-free").setAttribute("disabled","disabled");
             el.querySelector("button.minus-free").removeAttribute("disabled");
           }else{
             el.classList.add("opacity-5");
              el.querySelector("button.plus-free").setAttribute("disabled","disabled");
              el.querySelector("button.minus-free").setAttribute("disabled","disabled");
           }
           
         });
         this.submitButton.querySelector("span.bundle-message-free").classList.add("hidden");
         this.submitButton.querySelector("span.add-to-cart-message-free").classList.remove("hidden");
          this.submitButton.removeAttribute("disabled");
         
       }else{
         this.querySelectorAll(".product-bundle-item-wrapper-free").forEach( (el) => {
           el.querySelector("button.plus-free").removeAttribute("disabled");
           el.classList.remove("opacity-5");
         });
         this.submitButton.querySelector("span.add-to-cart-message-free").classList.add("hidden");
         this.submitButton.querySelector("span.bundle-message-free").classList.remove("hidden");
         this.submitButton.setAttribute("disabled","disabled");
       }
    }
    openQuantityBoxFree(evt){
        evt.preventDefault();
        let isFilled = true;
        const parentElement = evt.target.parentElement;
        const currentParentElement = evt.target.closest('.product-bundle-item-wrapper-free');
        currentParentElement.querySelectorAll(".custom-option-selector").forEach( (el) => {
          if(el.value == ""){
            isFilled = false;
            el.classList.add("has-error");
          }else{
             el.classList.remove("has-error");
          }  
        });
        if(isFilled == true){
          parentElement.querySelector(".quantity-button-free.plus-free").click();
          parentElement.querySelector(".product-bundle-item-quantity-wrapper").classList.remove("hidden");
          evt.target.classList.add("hidden");
        
         currentParentElement.classList.add("active");
        }
    }
   
    quantityChangeHandlerFree(evt){
      evt.preventDefault();
      const inputElement = evt.target.parentElement.querySelector('.custom-qty-box-input');
       const currentParentElement = evt.target.closest('.product-bundle-item-button');
      if(evt.target.classList.contains('plus-free')){
        
        if(this.freeQuantityCounter < this.maxNumber){
          inputElement.stepUp();
          this.freeQuantityCounter++;
        }
        currentParentElement.querySelector(".display-qty").textContent= inputElement.value;
        if(inputElement.value > 0){
          evt.target.parentElement.querySelector('button.minus-free').removeAttribute("disabled");
        }
      }else{
        if(this.freeQuantityCounter > 0){
          inputElement.stepDown();
          this.freeQuantityCounter--;
          currentParentElement.querySelector(".display-qty").textContent= inputElement.value;
        }
        
        if(inputElement.value <= 0){
          evt.target.parentElement.querySelector('button.minus-free').setAttribute("disabled","disabled");
          currentParentElement.querySelector(".product-bundle-item-quantity-wrapper").classList.add("hidden");
          currentParentElement.querySelector(".custom-item-qty-opener-free").classList.remove("hidden");
        }
      }
      this.updateButtonState(this.maxNumber);
      
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if(this.querySelectorAll(".product-bundle-item-quantity-wrapper .custom-qty-box-input").length <= 0){
        return false;
      }
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const selectedSize = document.querySelector(`.custom-variant-noflex-items select[name="option-selector"]`).value;
      
      let items = [];
      this.mainId = 0;
      this.querySelectorAll(".product-bundle-item-quantity-wrapper .custom-qty-box-input").forEach( (el) => {
        if(el.value > 0){
          const color = el.dataset.color;
          const selectedVaraint = this.variantJSON.filter(variant => variant.option1.match(color) && variant.option2 == selectedSize);
            if(selectedVaraint.length > 0){
              items.push({
                "id":selectedVaraint[0].id,
                "quantity":el.value,
              });
               this.mainId = selectedVaraint[0].id;
            }
          }
        
      });
      
      if(items.length <= 0){
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.setAttribute("disabled","disabled");
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return false;
      }
      let formData = {
       'items':items,
        'sections':this.cart.getSectionsToRender().map((section) => section.id),
        'sections_url':window.location.pathname
      };
      
      fetch(`${routes.cart_add_url}.js`,{
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: this.mainId, errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: this.mainId});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          this.closest(".custom-modal__centered.active").classList.remove("active");
           $("body").removeClass("remove-zindex");
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
      
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}